export enum SummaryDataHooks {
  ROOT = 'summary-root',
  DURATION = 'summary-duration',
  SERVICES = 'summary-services',
  LOCATION = 'summary-location',
  OPEN_PREFERENCES_BUTTON = 'summary-open-preferences-button',
}
